import type { Editor } from 'ckeditor5'
import {
  Plugin,
  toWidget,
  viewToModelPositionOutsideModelElement,
  Widget,
} from 'ckeditor5'

// TODO - delete
export class TabSpacesPlugin extends Plugin {
  static get requires() {
    return [Widget]
  }

  static get pluginName() {
    return 'TabSpacesPlugin'
  }

  init(): void {
    const editor = this.editor as Editor
    const model = editor.model
    const doc = model.document

    model.schema.register('tab', {
      allowWhere: '$text',
      isInline: true,
      isObject: true,
    })

    editor.editing.mapper.on(
      'viewToModelPosition',
      viewToModelPositionOutsideModelElement(model, (viewElement) =>
        viewElement.hasClass('ck-tab')
      )
    )

    editor.conversion.for('editingDowncast').elementToElement({
      model: 'tab',
      view: (modelItem, { writer: viewWriter }) => {
        const span = viewWriter.createContainerElement('span', {
          class: 'ck-tab',
          contenteditable: 'false',
        })
        viewWriter.insert(
          viewWriter.createPositionAt(span, 0),
          viewWriter.createText('\u00A0\u00A0\u00A0')
        )

        return toWidget(span, viewWriter, { label: 'tab spaces' })
      },
    })

    editor.conversion.for('dataDowncast').elementToElement({
      model: 'tab',
      view: (modelItem, { writer: viewWriter }) => {
        const span = viewWriter.createContainerElement('span', {
          class: 'ck-tab',
        })
        viewWriter.insert(
          viewWriter.createPositionAt(span, 0),
          viewWriter.createText('\u00A0\u00A0\u00A0')
        )
        return span
      },
    })

    editor.conversion.for('upcast').elementToElement({
      view: {
        name: 'span',
        classes: 'ck-tab',
      },
      model: 'tab',
    })

    editor.keystrokes.set('Tab', (evtData, cancel) => {
      model.change((writer) => {
        const tab = writer.createElement('tab')
        model.insertContent(tab, doc.selection)
      })
      cancel()
    })
  }
}
